// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveScheduleSubPhasesMutationVariables = Types.Exact<{
  input: Types.SaveScheduleSubPhasesInput;
}>;


export type SaveScheduleSubPhasesMutation = { __typename?: 'Mutation', saveScheduleSubPhases: { __typename?: 'SaveScheduleSubPhasesResult', scheduleSubPhases: Array<{ __typename?: 'ScheduleSubPhase', id: string, name: string, schedulePhase: { __typename?: 'SchedulePhase', id: string, name: string } }> } };


export const SaveScheduleSubPhasesDocument = gql`
    mutation SaveScheduleSubPhases($input: SaveScheduleSubPhasesInput!) {
  saveScheduleSubPhases(input: $input) {
    scheduleSubPhases {
      id
      name
      schedulePhase {
        id
        name
      }
    }
  }
}
    `;
export type SaveScheduleSubPhasesMutationFn = Apollo.MutationFunction<SaveScheduleSubPhasesMutation, SaveScheduleSubPhasesMutationVariables>;

/**
 * __useSaveScheduleSubPhasesMutation__
 *
 * To run a mutation, you first call `useSaveScheduleSubPhasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleSubPhasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleSubPhasesMutation, { data, loading, error }] = useSaveScheduleSubPhasesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduleSubPhasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScheduleSubPhasesMutation, SaveScheduleSubPhasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScheduleSubPhasesMutation, SaveScheduleSubPhasesMutationVariables>(SaveScheduleSubPhasesDocument, options);
      }
export type SaveScheduleSubPhasesMutationHookResult = ReturnType<typeof useSaveScheduleSubPhasesMutation>;
export type SaveScheduleSubPhasesMutationResult = Apollo.MutationResult<SaveScheduleSubPhasesMutation>;
export type SaveScheduleSubPhasesMutationOptions = Apollo.BaseMutationOptions<SaveScheduleSubPhasesMutation, SaveScheduleSubPhasesMutationVariables>;